import {
  buildCartEstimatePayload,
  buildLegacyEstimateUrls,
} from './cart-hds-premium-points-core-v2.js';

/** Berekent HDS Premium-punten in één keer over de volledige winkelmand. */
(function () {
  if (window.__hdsCartPremiumPointsInit) return;
  window.__hdsCartPremiumPointsInit = true;

  var SEL = '[data-hds-cart-premium-root]';
  var DEBOUNCE_MS = 250;
  var debounceTimer = null;

  function formatPoints(sum) {
    var suffix = sum === 1 ? ' punt' : ' punten';
    return '+' + sum.toLocaleString('nl-NL') + suffix;
  }

  function setAllValues(text) {
    document.querySelectorAll(SEL).forEach(function (root) {
      var el = root.querySelector('[data-hds-cart-premium-value]');
      if (el) el.textContent = text;
    });
  }

  function fetchLegacyCartPoints(payload) {
    return Promise.all(
      buildLegacyEstimateUrls(payload).map(function (url) {
        return fetch(url, {
          method: 'GET',
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        })
          .then(function (res) {
            if (!res.ok) return null;
            return res.json();
          })
          .then(function (data) {
            var points = Number(data && data.points);
            return Number.isFinite(points) ? points : null;
          });
      })
    ).then(function (results) {
      var valid = results.filter(function (points) {
        return points !== null;
      });
      return valid.length
        ? valid.reduce(function (sum, points) { return sum + points; }, 0)
        : null;
    });
  }

  function updateRoots(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var roots = scope.querySelectorAll(SEL);
    if (!roots.length) return;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (!cart.items || cart.items.length === 0) {
          setAllValues('—');
          return;
        }

        var first = roots[0];
        var fromCart = cart.currency;
        var currency =
          (first && first.dataset && first.dataset.currency) ||
          (typeof fromCart === 'string' ? fromCart : fromCart && fromCart.iso_code) ||
          'EUR';
        var customerEmail = (first && first.dataset && first.dataset.customerEmail) || '';
        var payload = buildCartEstimatePayload(
          cart,
          String(currency).toUpperCase(),
          customerEmail
        );
        if (!payload.lines.length) {
          setAllValues('—');
          return;
        }

        return fetch('/apps/loyalty-points', {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify(payload),
        })
          .then(function (res) {
            if (!res.ok) return fetchLegacyCartPoints(payload);
            return res.json();
          })
          .then(function (data) {
            var rawPoints = typeof data === 'number' ? data : data && data.points;
            var points = rawPoints === null || rawPoints === undefined
              ? NaN
              : Number(rawPoints);
            setAllValues(Number.isFinite(points) ? formatPoints(points) : '—');
          });
      })
      .catch(function () {
        setAllValues('—');
      });
  }

  function schedule(root) {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      debounceTimer = null;
      updateRoots(root);
    }, DEBOUNCE_MS);
  }

  window.hdsRefreshCartPremiumPoints = function (root) {
    schedule(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  document.addEventListener('cart:update', function () {
    schedule();
  });
})();
